import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { twMerge } from "../../../types/twMerge";
import { FONT_MAP, FONT_SIZE_MAP } from '../../../../utils/commonRingUtils';
import { IOption, ISwatchContent } from '../../../types/customizer';
import If from '../../If';

export interface IKayEngravingFilterProps {
  content: ISwatchContent;
  onChange: (updated: any) => void;
  innerTab?: number;
  isFetching: boolean;
}

const KayEngravingFilter = ({ content, onChange, isFetching, innerTab = 1 }: IKayEngravingFilterProps) => {

  const options: Array<IOption> = content.options as Array<IOption>;
  const { selectedOption, engravingText } = content;
  const [font, setFont] = useState<IOption>();
  const [text, setText] = useState('');

  useEffect(() => {
  /**
   * For Engraving tab, set selectedOption and text in state to manage local state change
   */
    setText(engravingText || '');
    setFont(selectedOption);
  }, [engravingText, selectedOption]);

  const handleFontChange = (updatedObj: Record<string, string>) => {
    const sku = Object.values(updatedObj)[0];
    const selectedFont = options.find(item => item.type === 'option' && item.sku === sku);
    if (selectedFont?.type === 'option') {
      if (!font || selectedFont?.sku !== font.sku) {
        setFont(selectedFont);
      }
      handleUpdate(selectedFont, selectedFont.sku === 'NONE' ? '' : text);
    }
  };

  const handleTextChange = (e: any) => {
    if (isFetching) {
      return;
    }
    const { value } = e.target;
    if (value.length <= 35) {
      setText(value);
    }
  };

  const handleFontNameChange = (e: any) => {
    const { value } = e.target;
    if (font) {
      const updatedFont = {
        ...font,
        name: value,
      };
      setFont(updatedFont);
    }
  };

  const handleBlur = () => {
    if(engravingText !== text) {
      handleUpdate(font, text);
    }
  }

  const handleFontNameBlur = () => {
    if(selectedOption?.name !== font?.name) {
      handleUpdate(font, text);
    }
  }

  const handleUpdate = (font: IOption | undefined, text: string) => {
    const engraving_new = `I_${font?.sku}-${font?.name}_${text}`;
    /**
     * Check font name is availble to check custom font is availble
     * then check if none then allow to update
     * Else text is available then allows to update
     */
    if (font?.name && (font?.sku === 'NONE' || text)) {
      onChange({ engraving_new });
    }
  }

  const handleFontClick = (option: IOption) => () => {
    handleFontChange({ [option.sku]: option.sku });
  }

  return (
    <>
      <div className="tw-overflow-auto tw-grid tw-gap-3 tw-grid-cols-[repeat(auto-fit,minmax(192px,1fr))]">
        {options.map((option: IOption, index: number) => (
          <div
            key={index}
            onClick={handleFontClick(option)}
            className={clsx(`tw-text-sm ${option.additionalClassName || ''}`, {
              'light-border': option.sku !== font?.sku,
              'dark-border': option.sku === font?.sku
            })}
          >
            {option.sku === 'CUSTOM' ? option.sku : option.name}
          </div>
        ))}
      </div>
      <If condition={font && font.sku !== 'NONE'}>
        <If condition={font?.sku === 'CUSTOM'}>
          <div className="tw-mt-5 tw-flex tw-flex-col tw-justify-between tw-mr-3">
            <div className="tw-text-base tw-py-2">Font Name</div>
            <div className="tw-text-right tw-w-full">
              <input
                type="text"
                value={font?.name || ''}
                onChange={handleFontNameChange}
                onBlur={handleFontNameBlur}
                placeholder="(none)"
                className={clsx({
                  'tw-px-4 tw-py-1.5 tw-h-9 tw-w-full tw-text-sm tw-text-black tw-text-right tw-border tw-border-solid tw-border-gray-400 tw-outline-none': true,
                  'tw-border-red': font?.name.length === 0
                })}
              />
            </div>
          </div>
        </If>
        <div className="tw-flex tw-flex-col tw-justify-between tw-mr-3">
          <div className="tw-text-base tw-py-2">Engraving Text</div>
          <div className="tw-text-right tw-w-full">
            <input
              type="text"
              value={text}
              onChange={handleTextChange}
              onBlur={handleBlur}
              placeholder="(none)"
              className={twMerge(clsx({
                'tw-px-4 tw-py-1.5 tw-h-9 tw-w-full tw-text-sm tw-text-black tw-text-right tw-border tw-border-solid tw-border-gray-400 tw-outline-none': true,
                'tw-border-red': text.length === 0
              },
              `${FONT_MAP[font?.name || '']}`,
              `${FONT_SIZE_MAP[font?.name || '']}`
              ))}
            />
            <div className="tw-text-sm tw-text-cyan tw-font-normal tw-mt-2">{(35 - text.length)} characters left</div>
            <div className="tw-text-sm tw-text-cyan tw-font-normal tw-mt-2">*Note: Engraving text will not appear on the ring image.</div>
          </div>
        </div>
      </If>
    </>
  );
};

export default KayEngravingFilter;

